
export default function BoltSuperlative({data}) {
  return (
    <>
      <section className="bolt-superlative-area">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="bolt-superlative-content">
                <h2 className="heading center-heading">{data && data.titlePart1} <span className="gradiant-color">{data && data.titlePart2}</span> {data && data.titlePart3}</h2>
                <p>{data && data.description1}</p>
                <p>{data && data.description2}</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
